<template>
    <div class="about" style="background-color: #FFFFFF;">
        <van-sticky>
            <van-nav-bar title="用户协议" :border="false" left-arrow @click-left="goBack">

            </van-nav-bar>
        </van-sticky>

        <div style="font-size: 12px;color:#515a6e;padding: 10px 15px; background-color: #FFFFFF;">

            <div class="wcc-header-2">1 关于我们</div>
            <div class="wcc-content">
                “随申查”应用软件及相关技术与功能 (以下合称为“本服务”) 由上海新兴信息通信技术应用研究院（以下称“我们”或“研究院”）运营。本协议中的“您”与“用户”指任何使用和/或访问本服务的个人。
            </div>

            <div class="wcc-header-2">2 协议目的</div>
            <div class="wcc-content">本用户协议、隐私声明(您可前往“随申查”的“我的”>“关于我们”>“隐私声明”阅读隐私声明) 及本服务发布的其它政策 (以下合称为“本协议”)
                是我们为您提供本服务以供使用及访问所依据的条款。通过本协议，您将了解研究院、研究院向您提供本服务的方式、本服务所允许及禁止的活动、应对问题的措施及其它重要信息。请仔细阅读本协议。若您使用本服务，则视为您已与研究院达成具有法律约束力的协议。若您不接受本协议，请勿使用本服务。
            </div>


            <div class="wcc-header-2">3 使用资格</div>
            <div class="wcc-content">
                您需年满18周岁，或达到您所在地区的法定成年年龄，方可访问并使用本服务。若您未满18周岁或未达到您所在地区的法定成年年龄，则请您在您的父母或法定监护人的陪同下阅读本协议，并获得您的父母或法定监护人同意后方可使用本服务。
            </div>


            <div class="wcc-header-2">4 访问本服务</div>
            <div class="wcc-content">研究院授予您依照本协议访问及使用本服务的有限的、非独家、不可转让、不可转授，但可撤销的许可。
            </div>


            <div class="wcc-header-2">5 本服务</div>
            <div class="wcc-content">研究院“随申查”是一款提供对移动网络和WIFI网络上传、下载、以及时延测试的网络测速和检测诊断专业工具，具备安装简单、使用方便、结果准确等特点。
                本服务可支持运营商2G/3G/4G/5G网络，以及WIFI网络测速以及时延抖动测试，可实时准确地为用户诊断网络状态。
            </div>

            <div class="wcc-header-2">6 第三方服务</div>
            <div class="wcc-content">
                本应用中的的定位和地图服务由第三方服务提供商高德软件有限公司提供。您同意，您将与第三方就对应服务订立合同（下称“第三方协议”）。研究院不是您与第三方服务提供商订立的第三方协议中的一方，因此我们强烈建议您仔细阅读第三方协议及第三方隐私政策。是否使用第三方服务将由您自己做出决定。如果您决定使用第三方服务，其可能带来的结果和风险全部由您自己承担。研究院无权也没有义务控制或审查第三方服务提供商所提供产品或服务的内容，对于您在使用此类第三方产品与服务时遭受的权益侵犯，研究院不承担任何责任。研究院不对任何第三方产品或服务的内容或可用性负责，也不为第三方在本服务中提供的任何内容、广告、产品、服务或其它信息作出任何形式的背书。若您不遵守第三方协议和/或第三方隐私政策，第三方可能对您采取法律行动。
                通过本服务使用第三方产品与服务导致的任何争议由第三方服务提供商解决，研究院对此不承担任何责任。研究院不为第三方软件或技术提供任何客户支持。若您需要支持，需联系第三方服务提供商。
                各第三方服务提供商为其产品、服务及其内容及所作保证承担全部责任。若出现争议，以第三方服务提供商的产品或服务保证或第三方协议的约定为准。
            </div>

            <div class="wcc-header-2">7 帐户安全</div>
            <div class="wcc-content">
                您应妥善保管您的随申查帐号用户名与密码等信息（下称“帐户信息”），不得与任何人分享此类信息。我们建议您选择安全等级高的密码并妥善保管该密码。您有责任保障您的密码安全。若您将帐户信息细节提供给第三方，由此导致的任何损失与责任应由您自行承担。
                若您认为有人可能在使用您的帐户信息，则您应通过“联系我们”章节中的联络信息立即告知我们。您不得使用其他人的帐号来访问本服务。您应采取恰当的措施来保护您的帐户信息，避免第三方未经授权使用您的前述信息。
            </div>


            <div class="wcc-header-2">8 使用规则</div>
            <div class="wcc-content">
                您承诺并同意以合法道德的方式依照本协议访问并使用本服务。您理解并同意，您不得使用本服务传输任何带有以下性质的信息，或通过其它方式参与任何带有以下性质的活动：虚假、诽谤、侵权、有害、色情、攻击、欺侮、骚扰、丑闻、仇恨、煽动、威胁、亵渎、淫秽、侵犯隐私或在其它方面令人反感，包括但不限于助长违法活动、存在明显性描述、宣扬暴力，以及任何歧视性的、违法的、造成或可能造成人身财产损失或伤害、可能引起适用法律下的民事或刑事责任的信息和行为
                (包括但不限于任何您无权发布或传输的信息，或此类发布或传输违反任何保密义务和/或第三方知识产权的情况)。
            </div>
            <div class="wcc-content">您同意不会进行以下任何活动：
            </div>
            <div class="wcc-content">(a) 复制或更改本服务的全部或部分内容，或允许本服务或其中任何部分与其它任何程序合并或合入其它任何程序；</div>
            <div class="wcc-content">(b) 未经授权访问或尝试访问或损害本服务或相关系统或网络的任何部分；</div>
            <div class="wcc-content">(c) 分解、解码或逆向开发本服务或其任一部分，或基于本服务或其任一部分创造衍生作品，或企图从事适用法律禁止的类似活动；</div>
            <div class="wcc-content">(d) 分发、许可、租赁、出售、转售、转让、公开展示、公开表演、传输、播放、传播或以其它方式使用本服务；</div>
            <div class="wcc-content">(e) 未经研究院事先书面许可，以任何形式将本服务全部或部分内容 (包括标的物及源代码) 提交或以其它方式提供给任何人；</div>
            <div class="wcc-content">(f) 冒充他人、伪称或以其它方式虚报您与某人或某实体的关系；</div>
            <div class="wcc-content">(g) 出于非法目的，以任何不法形式，或违反本协议的方式使用本服务 (或其任何部分)，或实施任何欺诈或其它恶意行为，包括但不限于入侵本服务 (或本服务链接的网址)
                或任何操作系统或向其植入恶意代码，包括病毒或有害数据；
            </div>
            <div class="wcc-content">(h) 访问和/或使用本服务时侵犯我们或任何第三方的知识产权；</div>
            <div class="wcc-content">(i) 搜集本服务用户的信息，或使用自动化手段来访问本服务或随申查系统，或试图通过破译向运行本服务的服务器中传入任何内容或从中提取任何内容；</div>
            <div class="wcc-content">(j) 开发、支持或使用软件、设备、脚本或任何其它手段或进程 (包括爬虫软件、浏览器插件或任何其它技术或人为作业)
                来攫取本服务或以其它方式从本服务中拷贝用户信息及其它数据；
            </div>
            <div class="wcc-content">(k) 未经研究院事先书面许可将本服务用于商业用途；</div>
            <div class="wcc-content">(l) 使用本服务从事任何违法商业交易，比如贩卖军火、毒品、非法物品、盗版软件或其它违禁品；</div>
            <div class="wcc-content">(m) 提供赌博信息或使用任何手段引诱他人赌博；</div>
            <div class="wcc-content">(n) 索要他人登录信息或访问他人帐户；</div>
            <div class="wcc-content">(o) 参与洗钱、套现或传销活动；</div>
            <div class="wcc-content">(p) 违反本协议 (或其中任何部分)，或助推或怂恿此类行为；或</div>
            <div class="wcc-content">(q) 使用本服务时损害、禁用、削弱或危及本服务、随申查系统或其安全，或使其超负荷，干扰其他用户或任何其他方的电脑系统，入侵或未经授权访问本服务或研究院内容
                (定义见下) 或数据。
            </div>


            <div class="wcc-header-2">9 使用研究院内容</div>
            <div class="wcc-content">
                研究院和/或研究院的许可方对根据本服务或经由本服务获得的所有信息，包括但不限于文本、视频和音频、图片、图标、应用、设计、软件、脚本、程序、版权、商标、商号、标志及其它资料与服务，以及包括前述内容的外观与体验
                (以下合称为“研究院内容”) 保留所有权利。除非本协议另行规定，否则您对本服务的访问和/或使用并不构成本服务或其中内容的任何所有权或其它权利向您或其他任何人的转移。
                您不得通过任何方式更改、复制、提取、修订或增添研究院内容，也不得出售、拷贝、传播、许可或滥用研究院内容。若您需重新发布、提取、复制、传播或以其它方式使用任何研究院内容，您必须提前联系研究院并获得研究院的事先书面许可，本协议明确说明的情形除外。这并不影响您依照适用的强制法律所享有的任何权利。
                若您认为本服务或其任何部分侵犯了任何版权、商标、专利、商业机密或其它知识产权，或您对本服务存在其它疑虑，请通过“联系我们”章节中的联络信息告知我们。
            </div>


            <div class="wcc-header-2">10 您的内容</div>
            <div class="wcc-content">
                对于您上传、发布及以其它方式传输至本服务或通过本服务传输的文本、文件、图片、照片或其它信息 (以下合称为“您的内容”)，您继续保留对您的内容的所有权；您对您的内容全权负责。
            </div>


            <div class="wcc-header-2">11 对本服务的管理</div>
            <div class="wcc-content">
                您理解，在符合适用的法律法规前提下，出于运营及改善本服务的目的
                (包括但不限于欺诈防范、风险评估、调查及客户支持)，我们有权采取必要措施确保您遵守本协议及适用的法律，或法院、政令、行政机关或其它政府机关的命令或要求。
            </div>


            <div class="wcc-header-2">12 隐私与数据收集</div>
            <div class="wcc-content">
                为了向您提供更稳定的服务，保证您的交易安全，研究院会根据本服务的隐私声明收集并处理您的个人信息。
            </div>

            <div class="wcc-header-2">13 免责声明</div>
            <div class="wcc-content">
                本服务仅供您个人使用，不得提供给任何第三方使用。您同意，对未经授权使用本服务导致的任何损失，研究院及研究院负责人、理事、员工、承包商、代理、第三方支付服务提供商、合作伙伴、许可方及经销商
                (以下合称为“研究院方”) 不承担任何责任。
            </div>
            <div class="wcc-content">
                本服务在使用过程中可能会因不可控制的原因在未知时段内中断、延迟或受到干扰。您同意，对前述中断、延迟、干扰或类似故障导致的或与之相关的任何申索，研究院方不承担任何责任。
            </div>
            <div class="wcc-content">
                在适用法律允许的最大范围内，对于您或其他任何人因下列原因无法访问或使用本服务导致的任何损害，研究院方不承担任何责任：
            </div>

            <div class="wcc-content">(a) 研究院对系统或软硬件进行维护或升级导致本服务中止或终止；</div>
            <div class="wcc-content">(b) 非研究院拥有或控制的系统或网络通讯延迟或出现故障；</div>
            <div class="wcc-content">(c) 研究院与任何第三方支付服务提供商之间的合同或其它约定中止、取消或终止；</div>
            <div class="wcc-content">(d) 由于黑客攻击或类似的安全影响导致错误或中断；或</div>
            <div class="wcc-content">(e) 超越研究院合理控制的其它原因。</div>

            <div class="wcc-content">
                本服务按照“现状”和“现有”提供，且不做任何形式的保证或背书。在适用的法律允许的最大范围内，研究院方未就以下方面承认任何明示或默示的保证、条件或其它协定，也未就此作出任何担保、承诺、声明或保证：
            </div>

            <div class="wcc-content">(a) 根据本服务或经由本服务获得的任何内容的完整性、准确性、可靠性或及时性；</div>
            <div class="wcc-content">(b) 本服务或承载本服务的服务器是否存在缺陷、错误、病毒、漏洞或其它有害元素；</div>
            <div class="wcc-content">(c) 本服务运营或功能方面的缺陷是否会得到修正；</div>
            <div class="wcc-content">(d) 与本服务特定功能相关的保证，或您在使用或访问本服务时获得的任何信息是否可靠、优质或准确；</div>
            <div class="wcc-content">(e) 本服务是否安全无误；及</div>
            <div class="wcc-content">(f) 本服务是否可靠、优质、准确、可用或能够满足您的需求、能够产生特定的结果或实现特定的结果或成果。因全部或部分依赖、使用或诠释本服务，或因您 (或其他任何人)
                访问和/或使用本服务时获得的信息而造成的任何损失或损害，研究院方不承担任何责任。
                部分国家的法律不允许合同中排除或限制某些保证、担保或责任。若这些法律适用于您，则前述排除或限制条款的全部或部分可能不适用于您。本协议中的任何内容均不影响您作为消费者应该享有的法定权利，您也无法通过同意本合同来变更或放弃这些权利。
            </div>


            <div class="wcc-header-2">14 由您终止</div>
            <div class="wcc-content">
                您可停止使用本服务来终止本协议。
            </div>

            <div class="wcc-header-2">15 由研究院终止或中止</div>
            <div class="wcc-content">
                我们可能依照适用法律在任何时候临时性或永久性中止、取消或限制您访问全部或部分本服务，而不对任何个人或第三方承担任何责任。我们会在采取前述行动前尽全力通知您。但若出现如下情形，我们可能在不事先通知您的情况下立即永久性或临时性限制、取消或终止您访问全部或部分本服务：
            </div>

            <div class="wcc-content">(a) 您违反或研究院有理由认为您即将违反本协议，包括其中包含的任何约定、政策或指南；</div>
            <div class="wcc-content">(b) 您或代表您行事的任何人进行欺诈或违法活动，或向研究院提供虚假或误导信息；</div>
            <div class="wcc-content">(c) 依照有效法律程序响应执法部门或政府机关提出的要求；</div>
            <div class="wcc-content">(d) 为执行紧急的系统或硬件维护或更新工作；或</div>
            <div class="wcc-content">(e) 因无法预料的技术、安全或业务原因。</div>


            <div class="wcc-content">本协议的到期或终止不影响本协议中明确说明在其失效或终止后仍可操作或继续有效的条件，也不影响任何应计权益或义务或任何应在本协议失效或终止后继续有效的权利或义务。
                v任何本协议中明示或依其性质应当在协议终止后继续有效的条款，将在本协议终止后继续保持其完整效力，直至这些条款中的条件被满足或者依其性质应当到期为止。
            </div>

            <div class="wcc-header-2">16 对本协议的修订</div>
            <div class="wcc-content">
                研究院一直在更新、修订和改善本服务。研究院可能为本服务增删功能或性能，设置新的限制或临时中止或永久停止提供某项服务；研究院也可能基于本服务的更新随时修订本协议。
                若对本服务或本协议的修订会严重影响用户或严重限制对本服务的访问或使用，我们会在变更之前的合理时间内通知您。对于为了满足安全、法律或监管要求而对本服务作出的修订，我们可能无法满足前述的预告时间要求，但我们会尽快通知您。
            </div>

            <div class="wcc-header-2">17 适用法律及管辖</div>
            <div class="wcc-content">
                本协议适用法律为中华人民共和国法律。您和研究院同意，本协议签订地为中国上海市浦东新区。在合同履行过程中双方如发生纠纷，应协商解决；协商不成的，双方应向协议签订地有管辖权的人民法院以诉讼的方式解决。
            </div>

            <div class="wcc-header-2">18 一般条款</div>
            <div class="wcc-content">
                本服务或第三方可能会提供其它网站或资源的链接。您理解并同意，我们不为此类外部网站或资源的可用性负责，也不对此类网站或资源上，或由此获得的任何内容、广告、产品或其它信息作出任何形式的背书或承担任何责任。因您使用或依赖任何根据或经由此类网站或资源获得的任何内容、商品或服务而导致的或声称由此导致或与之相关的任何损害或损失，我们不承担任何责任。
                本协议中的任何内容均不得视为在您与研究院之间建立了任何合作或代理关系。任何一方无权以另一方的名义或代表另一方产生任何责任债务或成本，或订立任何合同或其它约定。
                因研究院合理控制范围外的事件造成或导致研究院未能或延迟履行本协议或本服务条件中的义务，研究院不承担任何责任。 研究院有权转让、分包或更替研究院在本协议下的权利和义务。
                若本协议中的任何条款被有管辖权的法院或其它任何主管机构视为无效、失效或无法执行，则该条款应视为已从本协议中删除，但其它任何条款仍具有法律效力。
            </div>
            <div class="wcc-header-2">19 联系我们</div>
            <div class="wcc-content">
                如您对本协议有任何疑问，请通过如下信息联系我们：gongxingbo@saict.net
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {}
        },
        methods: {
            goBack: function () {
                if (window.JSInterface) {
                    window.JSInterface.callMethod('close', null)
                }
                else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface) {
                    window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"close\"}");
                }
            },
        }
    }
</script>

<style scoped>
    .wcc-header-1 {
        text-align: center;
        font-size: 1.2em;
        line-height: 2em;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .wcc-header-2 {
        font-size: 1.1em;
        line-height: 2em;
        font-weight: bold;
    }

    .wcc-content {
        text-indent: 2em;
        margin-bottom: 10px;
    }

    .van-nav-bar{
        background-color: #FFFFFF;
    }
</style>
